import { render, staticRenderFns } from "./sendexpress.vue?vue&type=template&id=12ca7d73&scoped=true&"
import script from "./sendexpress.vue?vue&type=script&lang=js&"
export * from "./sendexpress.vue?vue&type=script&lang=js&"
import style0 from "./sendexpress.vue?vue&type=style&index=0&id=12ca7d73&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ca7d73",
  null
  
)

export default component.exports